export default __webpack_public_path__ + "static/recipes-modal-bg-de818d342df9e2fd80e5fbf4d70b90f8.jpg";